"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
export function useAccumulateBatch(callback, t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    delay: t2,
    leading: t3,
    resetKey
  } = t1;
  const delay = t2 === undefined ? 3000 : t2;
  const leading = t3 === undefined ? true : t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const accumulated = useRef(t4);
  const timerRef = useRef(null);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const resetTimer = () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }
        accumulated.current = [];
      };
      resetTimer();
      return resetTimer;
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== resetKey) {
    t6 = [resetKey];
    $[4] = resetKey;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  useEffect(t5, t6);
  let t7;
  if ($[6] !== callback || $[7] !== delay || $[8] !== leading) {
    t7 = function batchFunction(item) {
      if (timerRef.current === null) {
        if (leading) {
          callback([item]);
        } else {
          accumulated.current.push(item);
        }
        timerRef.current = setTimeout(() => {
          if (accumulated.current.length > 0) {
            callback(accumulated.current);
            accumulated.current = [];
          }
          timerRef.current = null;
        }, delay);
      } else {
        accumulated.current.push(item);
      }
    };
    $[6] = callback;
    $[7] = delay;
    $[8] = leading;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const batchFunction = t7;
  return batchFunction;
}